module.exports = __webpack_public_path__ + "static/img/19.fa7a383.png";


//////////////////
// WEBPACK FOOTER
// ./src/project/articleProject/images/qlxj/19.png
// module id = ar3v
// module chunks = 5